var map = {
	"./bread.png": 96,
	"./covered.png": 97,
	"./cutlery.png": 98,
	"./dessert.png": 99,
	"./drinks.png": 39,
	"./fish.png": 100,
	"./meat.png": 101,
	"./salad.png": 102,
	"./soup.png": 103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;